import Vue from 'vue'
import App from '@/App.vue'
import router from './router'
import Mgr from '@/services/SecurityService'

Vue.config.productionTip = false
Vue.config.devtools = true

let mgr = new Mgr();

router.beforeEach((to, from, next) => {
    const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
    if (requiresAuth) {
        mgr.getUser().then(
            success => {
                if (success == null || success == false) {
                    console.log(success)
                    next('/')
                }
                else if (to.meta.role != null && to.meta.role.length > 0) {
                    if (!(success.profile != null && success.profile.role != null && success.profile.role.length > 0) || !(to.meta.role.some(r => success.profile.role.includes(r)))) {
                        next('/error/unauthorized')
                    }
                }
                next()
            },
            err => {
                console.log(err)
            }
        );
    } else {
        next()
    }
});

new Vue({
    router,
    render: h => h(App)
}).$mount('#app')
